import { CalendarAPI } from '../../../api/datamanager/CalendarAPI';

export class CalendarsCommand {
    getAll(successCallback, errorCallback) {
        const apiResult = CalendarAPI.list();
        apiResult.then((result) => {
            if (undefined !== successCallback) {
                successCallback(JSON.parse(result));
            }
        }).catch(() => {
            if (undefined !== errorCallback) {
                errorCallback("Ocorreu um erro a ler os Calendários");
            }
        });
    }
}
